export default __webpack_public_path__ + "static/media/appnovation.03aadde1.svg";